// extracted by mini-css-extract-plugin
module.exports = {"writeup":"writeup_writeup__xCeyX","input":"writeup_input__1Q0P0","button":"writeup_button__2RrLM","spacer":"writeup_spacer__2gq8A"};